import { environmentHttpClient } from "client/Api/httpClient";

export type ZermeloInterests = {
	daySchedule?: true;
	weekSchedule?: true;
};

export type ZermeloLiveInformationRequestModel = {
	connectionId: number;
	date: string;
	interestedIn: ZermeloInterests;
};

export enum ItemsResultStatus {
	GeneralFailure = 0,
	Success = 1
}

export type ZermeloScheduleResponseModel = {
	status: ItemsResultStatus;
	items: readonly ZermeloAppointment[];
};

export type ZermeloLiveInformationResponseModelData = {
	daySchedule?: ZermeloScheduleResponseModel;
	weekSchedule?: ZermeloScheduleResponseModel;
};

export type ZermeloLiveInformationResponseModel = {
	connectionId: number;
	date: string;
	interests: ZermeloInterests;
	isTeacher: boolean;
	data: ZermeloLiveInformationResponseModelData;
};

export enum AppointmentKind {
	Unknown = 0,
	Lesson = 1,
	Choice = 2,
	Interlude = 3,
	Exam = 4,
	Activity = 5,
	Conflict = 6
}

export type ZermeloAppointment = {
	id: number | null;
	kind: AppointmentKind;
	startDateTime: string;
	endDateTime: string;
	subjects: string[];
	groups: string[];
	locations: string[];
	teachers: string[];
	isOnline: boolean;
	remarks: string[];
	isCancelled: boolean;
	lessonNumber: string;
	url: string;
	choice: OptionalModel<AppointmentChoiceModel>;
};

export type AppointmentChoiceModel = {
	hasSelected: boolean;
	canBeChanged: boolean;
};

export function getLiveInformation(
	requests: ZermeloLiveInformationRequestModel[]
): Promise<readonly ZermeloLiveInformationResponseModel[]> {
	return environmentHttpClient.post<readonly ZermeloLiveInformationResponseModel[]>(
		"/Workspace/LiveInformation/Zermelo",
		requests
	);
};
